import type { Palette, PaletteMode, PaletteOptions } from '@mui/material';
import type { DefaultTheme } from '@mui/system';

export const getDesignTokens = (
  mode: PaletteMode,
  defaultTheme: DefaultTheme,
  darkPalette: Palette | PaletteOptions | null
): DefaultTheme => ({
  ...defaultTheme,
  palette: {
    ...(mode === 'light' ? defaultTheme.palette : darkPalette),
  },
});
